import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import ISubscription from "Types/Subscription";
import { State } from "store/reducers";

export const GET_SUBSCRIPTION = "[SUBSCRIPTION GET] GET_SUBSCRIPTION";
export const GET_SUBSCRIPTION_SUCCESS =
	"[SUBSCRIPTION GET] GET_SUBSCRIPTION_SUCCESS";
export const GET_SUBSCRIPTION_FAILED =
	"[SUBSCRIPTION GET] GET_SUBSCRIPTION_FAILED";

export const SET_VALUE = "[SUBSCRIPTION GET] SET_VALUE";
export const CLEAR_VALUES = "[SUBSCRIPTION GET] CLEAR_VALUES";

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getSubscription(
	id: string,
	callback?: Callback<ISubscription>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_SUBSCRIPTION });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/Subscription/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_SUBSCRIPTION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SUBSCRIPTION_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_SUBSCRIPTION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
